import styled from "styled-components";
import materialUI from "../../material-UI";

export const Button = styled(materialUI.Button)`
  text-transform: capitalize;
  background-color: ${(props) => props.style?.backgroundColor};

  &:hover {
    background-color: ${(props) => props.style?.backgroundColor};
  }
`;
